<template>
	<b-container>
		<b-breadcrumb :items="breadcrumb" style="margin-top: 15px;"></b-breadcrumb>
		<b-row>
			<b-col cols="1"></b-col>
			<b-col cols="10">
				<b-card bg-variant="light" style="margin-top: 15px;">
					<b-form>
						<b-row v-if="loadingComputingMetrics">CARGANDO CUBICACION</b-row>
						<div class="">
							<!-- <h2 class="title">{{$lang.worker.new}}</h2> -->
							<h2 class="title">cubicación</h2>
							<hr>
							<div class="form-division">
								<label for="file">{{$lang.computingMetrics.upload}}</label>
								<!-- <b-form-file id="file" v-model="computingMetrics.file" type="text" accept=".dxf" :browseText="$lang.computingMetrics.upload" :placeholder="$lang.computingMetrics.placeholder" @change="handleDocument"></b-form-file> -->
								<b-form-file id="file" class="text-nowrap text-truncate" v-model="computingMetrics.file" type="text" accept=".dxf" :browseText="$lang.computingMetrics.upload" :placeholder="$lang.computingMetrics.placeholder" @change="handleDocument"></b-form-file>
								<div class="mt-3">{{$lang.computingMetrics.selectedFile}}: {{ uploadedFile == true ? computingMetrics.file.name : 'N/A' }}</div>
							</div>
							<div class="form-division">
								<label for="id-number">{{$lang.computingMetrics.documentTitle}}</label>
								<b-form-input id="id-number" v-model="computingMetrics.documentName" type="text"></b-form-input>
							</div>

							<!-- <div class="form-division">
								<label for="layer-name">{{$lang.computingMetrics.layerName}}</label>
								<b-form-input id="layer-name" v-model="computingMetrics.layerName" type="text"></b-form-input>
							</div> -->

							<div class="form-division">
								<label for="computingMetricType">{{$lang.computingMetrics.type}}</label>
								<v-select v-model="computingMetrics.type" :options="$store.getters.computingMetricTypes" label="label" style="background-color: #FFF;" />
							</div>
							<div v-if="computingMetrics.data.length > 0">
								<hr>
									<vue-excel-xlsx class="btn title btn-primary btn-block" variant="primary"
										:data="computingMetrics.data"
										:columns="(computingMetrics.type.type != 'enfierradura' && computingMetrics.type.type != 'enfierraduralosas') ? (computingMetrics.type.type != 'tabiqueriablock' && computingMetrics.type.type != 'cieloblockk' && computingMetrics.type.type != 'revestimientoblock') ? excelLabels : tabiqueriablockLabels : enfierraduraLabels"
										:filename=computingMetrics.documentName
										:sheetname="'sheetname'"
										>
										{{ $lang.computingMetrics.export }}
									</vue-excel-xlsx>
								<br />
								<b-table striped hover outlined :items="computingMetrics.data" :fields="(computingMetrics.type.type != 'enfierradura' && computingMetrics.type.type != 'enfierraduralosas') ? (computingMetrics.type.type != 'tabiqueriablock' && computingMetrics.type.type != 'cieloblockk' && computingMetrics.type.type != 'revestimientoblock') ? fields : fieldsTabiqueriaBlock : fieldsEnfierradura" style="cursor:pointer">
									<template v-slot:cell(index)="data">
										{{ data.index + 1 }}
									</template>
									<template v-slot:cell(label)="data">
										{{ data.item.label }}
									</template>
									<template v-slot:cell(length)="data">
										{{ formatLength(data.item.length)}}
									</template>
									<template v-slot:cell(fi)="data">
										{{ formatLength(data.item.fi)}}
									</template>
								</b-table>
							</div>
							<hr>
							<div>
								<b-button variant="primary" class="title" block value="Save" v-on:click="createComputingMetrics" :disabled="validForm == false" >{{$lang.buttons.save}}</b-button>
								<b-button variant="danger"  class="title" block value="Cancel" @click="$router.go(-1)">{{$lang.buttons.cancel}}</b-button>
							</div>
						</div>
					</b-form>
				</b-card>
			</b-col>
			<b-col cols="1"></b-col>
		</b-row>
	</b-container>
</template>

<script>
import { mapState } from 'vuex'

// import DatePick from 'vue-date-pick'
// import { Money } from 'v-money'
const utils = require('../../utils.js');

export default {
	data() {
		return {
			breadcrumb: [],
			// money: utils.moneyConfig,
			dateFormat: utils.dateFormat,
			validForm: false,
			uploadedFile: false,
            computingMetrics: {
                file: [],
                documentName: '',
				type: {type: '', label: ''},
				data: []
            },
			excelLabels : [
                    {
                        label: "Tipo",
                        field: "label",
                    },
                    {
                        label: "Longitud",
                        field: "length",
						dataFormat: this.formatLength
                    },
					{
						label: "Metadata",
						field: "metadata"
					}
                ],
			tabiqueriablockLabels: [
				{
					label: "Block",
					field: "metadata"
				},
				{
					label: "Type",
					field: "label"
				},
				{
					label: "Largo",
					field: "length",
					dataFormat: this.formatLength
				},
			],
			enfierraduraLabels: [
				{
					label: "Enfierradura",
					field: "key"
				},
				{
					label: "Cantidad",
					field: "quantity"
				},
				{
					label: "Largo",
					field: "length"
				},
				{
					label: "Φ",
					field: "fiLabel"
				},
				{
					label: "Fi",
					field: "fi"
				},
				{
					label: "@",
					field: "dist"
				},
				{
					label: "Barra",
					field: "longitud",
					dataFormat: this.formatLength
				},
				{
					label: "Tipo",
					field: "type"
				}

			],
			fields: [
				{key: 'index', label: '#'},
				{key: 'label', label: 'Tipo'},
				{key: 'length', label: 'Longitud'},
				{key: 'metadata', label: 'Metadata'}
			],
			fieldsTabiqueriaBlock: [
				{key: 'index', label: '#'},
				{key: 'metadata', label: 'Block'},
				{key: 'label', label: 'Type'},
				{key: 'length', label: 'Largo'},
			],
			fieldsEnfierradura: [
				{key: 'index', label: '#'},
				{key: 'key', label: 'Tipo'},
				{key: 'quantity', label: 'Cantidad'},
				{key: 'length', label: 'Largo'},
				{key: 'fiLabel', label: 'Fi label'},
				{key: 'fi', label: 'Fi'},
				{key: 'dist', label: '@'},
				{key: 'longitud', label: 'Barra'},
				{key: 'label', label: 'Confirmation'}
			],
		}
	},
	components: {
		// DatePick,
		// Money
	},
	computed: {
		...mapState(['loadingComputingMetrics']),
	},
	methods: {
		createComputingMetrics () {
			this.$store.dispatch('createComputingMetric', this.computingMetrics)
			this.$router.push('/computingMetrics')
		},
		createBreadcrumb() {
			this.breadcrumb.push({'text': this.$lang.modules.computingMetrics, 'href': '/computingMetrics'})
			this.breadcrumb.push({'text': 'Formulario'})
		},
        handleDocument(event) {
			this.computingMetrics.documentName = event.target.files[0].name
			this.validForm = true;
			this.uploadedFile = true;
        },
		formatLength(value) {
			// console.log(value)
			// console.log(Number(value).toLocaleString('es-CL'))
			return value;
		}
	},
	beforeMount() {
		this.$Progress.start()
	},
	created() {
		this.$Progress.start()

		if(this.$route.params.computingMetricId) {
			let computingMetricId = this.$route.params.computingMetricId
			this.$store.dispatch('fetchComputingMetric', { computingMetricId }).then( () => {
				this.computingMetrics = this.$store.getters.computingMetric;
				console.log(this.computingMetrics)
			} )
		}
		this.createBreadcrumb()
		this.$store.dispatch('fetchComputingMetricTypes')
		this.$Progress.finish()
	}
}

</script>